import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environment';
import { NetworkService } from '@modules/core/services/network.service';
import { UsersService } from '@modules/users/services/users.service';
import { Account } from '@modules/users/types/account';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrl: './user-settings.component.less',
    standalone: false
})
export class UserSettingsComponent implements OnInit, OnDestroy {

  // Public
  public account?: Account;
  public uploading = false;
  public uploaded = false;
  public selectedFile: File | null = null;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    private usersService: UsersService,
    private networkService: NetworkService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    // Get Account
    this.usersService.getAccount()
      .pipe(takeUntil(this.alive))
      .subscribe(account => this.account = account);
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  updateAccount(): void {
    if (this.account) {
      this.usersService.updateAccount(this.account);
    }
  }

  uploadImage(event: any): void {
    const file = event.target?.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (this.account) {
          this.account.photoUrl = reader.result as string;
          this.updateAccount();
        }
      }
      reader.readAsDataURL(file);
    }
  }

  deletePhoto(): void {
    if (this.account) {
      this.account.photoUrl = undefined;
      this.updateAccount();
    }
  }

  selectCinedeckServerMsi(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      this.selectedFile = fileInput.files[0];
      this.uploaded = false;
      this.uploading = false;
    }
  }

  updateCinedeckServer(): void {
    if (!this.selectedFile) return;

    this.uploading = true;
    this.networkService.uploadCinedeckServer(this.selectedFile)
      .subscribe(() => {
        this.uploaded = true;
        this.uploading = false;
      });
  }

  openBullMQ(): void {
    const server = `http${environment.ssl ? 's' : ''}://${environment.api}`;
    window.open(`${server}/admin/queues`, '_blank');
  }

}

